// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="form-column">
    <form-section form-title="'Info'">
      <form-section-field field-title="'Phone serial number'">
        <input
          type="text"
          maxlength="256"
          ng-model="\$ctrl.device.serialNumber"/>
      </form-section-field>
      <form-section-field field-title="'Bluetooth printer serial number'">
        <input
          type="text"
          maxlength="256"
          ng-model="\$ctrl.device.bluetoothPrinterSerialNumber"/>
      </form-section-field>
      <form-section-field field-title="'Telco provider'">
        <select
          required
          ng-options="o.id as o.description for o in \$ctrl.telcoProviders"
          ng-model="\$ctrl.device.telcoProviderId">
        </select>
      </form-section-field>
      <form-section-field field-title="'Warranty expiry date'">
        <date
          ng-required="true"
          validate-date="gte:posting-date"
          ng-model="\$ctrl.device.warrantyExpiryDate"
          init-with-null="true">
        </date>
      </form-section-field>
    </form-section>
  </div>
</ng-form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/details/devices/device-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;